
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event",
      function () {
        return require("private-next-pages/event.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event"])
      });
    }
  